import {CustomEventHandler} from "../../utils/CustomEventHandler";
import {CUSTOM_SCROLL, isMobile, scrollSetting} from "../../common/globalVars";
import {HtmlUtil} from "../../utils/HtmlUtil";

export default class ScrollPin {
    constructor(triggerEl, targetEl, isCenter) {
        this.triggerEl = triggerEl;
        this.targetEl = targetEl;
        this.isCenter = isCenter;
        this.init();
    }

    init() {
        this.addEvent();
        // if (!scrollSetting.smooth)  this.targetEl.style.position = 'sticky';
    }

    addEvent() {
        this.onResizeHandler();
        this.onScrollHandler({detail:0});

        CustomEventHandler.addHandler(window, 'resize', (e)=>this.onResizeHandler(e));
        CustomEventHandler.addHandler(window, CUSTOM_SCROLL, (e)=>this.onScrollHandler(e));
    }

    onScrollHandler(e) {
        let triggerTop = HtmlUtil.getPos(this.triggerEl).y;
        let velocity = e.detail - triggerTop ;

        let maxVelocity =  this.triggerEl.offsetHeight - window.innerHeight;

        if (this.isCenter) {
            let motionTop = parseFloat(window.getComputedStyle(this.targetEl).top);
            let targetElHeight = parseFloat(window.getComputedStyle(this.targetEl).height);
            velocity = velocity  - targetElHeight/2 -motionTop;
            maxVelocity = maxVelocity - targetElHeight/2 - motionTop;
        }

        if(maxVelocity<0) {
            maxVelocity = 0;
        }

        this.onCustomScrollHandler(velocity, maxVelocity );

        if (velocity>0) {
            if (velocity > maxVelocity) {
                velocity = maxVelocity;
            }

            if (scrollSetting.smooth) this.targetEl.style.transform = `translate3d(0, ${velocity}px, 0)`;

        } else {
            if (scrollSetting.smooth) this.targetEl.style.transform = `translate3d(0, 0, 0)`;
        }
    }

    onCustomScrollHandler(velocity, maxVelocity) {

    }

    onResizeHandler() {

    }
}
